import React from 'react';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

import Image from '../../../base/Image';

import { useDetailsViewContext } from '../DetailsViewContext';

/**
 * Component for displaying resource image with responsive sizing
 */
export default function ResourceImage(/* props */) {
  const { publicData } = useDetailsViewContext();
  const [error, setError] = React.useState(false);

  return (
    <Grid id="resource-image" item container xs={12}>
      <Grid
        item
        container
        xs={12}
        sx={{
          p: { xs: 0, sm: 0 },
          mb: { xs: 0, sm: 0 },
          minHeight: error ? 0 : '140px',
          maxHeight: '200px',
        }}
      >
        <Image
          key={publicData?.resource?.imgUrl} // displays old image for short duration despite new url without this key. Changing key causes complete reinitialisation of component
          src={publicData?.resource?.imgUrl}
          showLoading
          duration={1000}
          fit="scale-down"
          enableBlurredBackground
          collapseOnError
          wrapperSx={{
            overflow: 'hidden',
            borderRadius: (theme) => `${theme.shape.borderRadius}px`,
          }}
          onError={() => setError(true)}
        />
      </Grid>
    </Grid>
  );
}

export function ResourceImageSkeleton() {
  return (
    <Skeleton
      variant="rectangular"
      width="100%"
      height={200}
      sx={{ borderRadius: (theme) => `${theme.shape.borderRadius}px` }}
    />
  );
}
